import * as actionTypes from "./printActionTypes";

export const toggleElementVisibility = (elementTag) => {
  return {
    type: actionTypes.TOGGLE_ELEMENT_VISIBILITY,
    payload: elementTag,
  };
};

export const setCurrentExposuresKeys = (keys) => {
  return {
    type: actionTypes.SET_CURRENT_EXPOSURES_KEYS,
    payload: keys,
  };
};
